export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_COUNTRIES = 'countries';
export const COLUMN_UPDATED = 'updated';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED = 'created';
